<div
  class="multi-select"
  [ngClass]="{
    'multi-select--disabled': !inlineMultiSelectInput.items.length && !inlineMultiSelectInput.searchWithApi
  }"
  (click)="presentPopover($event)"
>
  <div class="multi-select__btn">
    <div>{{ inlineMultiSelectInput.displayName | translate }}</div>
    <div class="multi-select__drop-down-chevron"></div>
  </div>
</div>
